var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 1.16602H6.66699C3.63335 1.16602 1.16699 3.63237 1.16699 6.66602V17.4993C1.16699 17.853 1.30747 18.1921 1.55752 18.4422C1.80757 18.6922 2.1467 18.8327 2.50033 18.8327H13.3337C16.3673 18.8327 18.8337 16.3663 18.8337 13.3327V6.66602C18.8337 3.63237 16.3673 1.16602 13.3337 1.16602ZM11.4005 9.56409L7.2926 13.666H6.33366V12.7075L10.4417 8.60537L11.4005 9.56409ZM12.8938 8.07152L11.935 7.1128L12.4977 6.55051L13.4564 7.50923L12.8938 8.07152Z",
    fill: "#26323E",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit_button.1264e2b26611739aca7ccd781184c980.svg";
export { ForwardRef as ReactComponent };